import AppLayout from "@/layouts/app/AppLayout";

import dashboard from "./dashboard"

export default [
  

  {
    path: "/exhibitor",
    component: AppLayout,
    meta: {
      middleware: ["auth"],
      roles: ["exhibitor"],
    },
    children: [
        ...dashboard,
    ],
  },
];
